import { render, staticRenderFns } from "./EmailTemplates.vue?vue&type=template&id=11254603&scoped=true"
import script from "./EmailTemplates.vue?vue&type=script&lang=js"
export * from "./EmailTemplates.vue?vue&type=script&lang=js"
import style0 from "./EmailTemplates.vue?vue&type=style&index=0&id=11254603&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11254603",
  null
  
)

export default component.exports